import { Injectable, inject } from '@angular/core';

import { AppConfig } from '@frontend/sports/common/client-config-data-access';
import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { HtmlNode } from '@frontend/vanilla/core';
import { remove } from 'lodash-es';

import { ModalRef } from '../common/modal-ref';
import { PopupAction } from '../common/modal-window.actions';
import { ModalGestureEvents } from './gesture/modal-gesture-events';
import { ModalDialogComponent } from './modal-dialog.component';

@Injectable({ providedIn: 'root' })
export class OpenedModalsStorageService {
    private htmlNode = inject(HtmlNode);
    private appConfig = inject(AppConfig);
    private dispatcher = inject(DispatcherService);

    private openedModals: ModalRef[] = [];

    set openedModal(modalRef: ModalRef) {
        this.openedModals.push(modalRef);
    }

    get activeModal(): ModalRef | undefined {
        return this.openedModals[this.openedModals.length - 1];
    }

    get count(): number {
        return this.openedModals.length;
    }

    removeCurrent(modalRef: ModalRef): void {
        remove(this.openedModals, (m) => m === modalRef);
    }

    tryCloseSeeAll(isBabPopup: boolean): void {
        if (!isBabPopup) {
            return;
        }

        const seeAll = this.openedModals.find(
            (m) => (m.componentInstance as ModalDialogComponent)?.dialogSettings.headerSelector === 'ms-option-panel-header',
        );

        if (seeAll && this.appConfig.modalDialogGesturesEnabled) {
            this.dispatchCloseWithGestureAnimationEvent(seeAll);
        } else {
            seeAll?.close({ closeAction: PopupAction.ManualClose });
        }

        this.htmlNode.setCssClass('sheet-view-for-market-for-sgp', false);
    }

    private dispatchCloseWithGestureAnimationEvent(modalRef: ModalRef): void {
        this.dispatcher.dispatch(ModalGestureEvents.SlideOutToBottom, {
            modalWindow: modalRef?.windowRef,
            teardown: () => modalRef?.close({ closeAction: PopupAction.ManualClose }),
        });
    }

    get edpModal(): ModalRef | undefined {
        return this.openedModals.find((m) => (m.componentInstance as ModalDialogComponent)?.dialogSettings.headerSelector === 'event-details-modal');
    }
}
